<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：登录页面
      -->
  <div class="login-bg" :style="'background-image:url(' + bgimg_url + ');'">
    <!-- <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
      <h3 class="title" style="margin-bottom: 20px;">{{shop_name}}</h3>
      用户名
      <el-form-item prop="account"><el-input type="text" @blur="getVerifyCode" v-model="ruleForm.account" auto-complete="off" placeholder="账号"></el-input></el-form-item>
      密码
      <el-form-item prop="checkPass"><el-input type="password"  v-model="ruleForm.checkPass" auto-complete="off" placeholder="密码"></el-input></el-form-item>
      短信验证码
      <el-form-item prop="code"><el-input type="text" v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input></el-form-item>
      登录
      <el-form-item><el-button type="primary" class="login_btn" style="width:100%;" @click.native.prevent="SubmitFunc" :loading="logining">登录</el-button></el-form-item>

    </el-form> -->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <h3 class="title" style="margin-bottom: 20px;">{{ shop_name }}</h3>
      <el-form-item prop="account">
        <el-input
          type="text"
          style="font-size: 18px;"
          v-model="ruleForm.account"
          auto-complete="off"
          placeholder="账号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input
          type="password"
          style="font-size: 18px;"
          v-model="ruleForm.checkPass"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="code"
        style="display: flex; justify-content: flex-start"
      >
        <el-input
          type="text"
          v-model="ruleForm.code"
          auto-complete="off"
          placeholder="验证码"
          style="font-size: 18px;margin-right: 10px;"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="sendCode"
          :disabled="codeSending"
          style="width: 180px;"
          >{{
            codeSending ? `重新发送(${codeTimer}s)` : "获取验证码"
          }}</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          class="login_btn"
          style="width:100%;"
          @click.prevent="SubmitFunc"
          :loading="logining"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import IndexApi from "@/api/index.js";
import bgimg from "@/assets/img/login_bg.png";
import UserApi from "@/api/user.js";
import { setCookie, getCookie, setSessionStorage } from "@/utils/base.js";
export default {
  data() {
    return {
      codeSending: false,
      codeTimer: 60,
      intervalId: null,

      /*是否正在加载*/
      loading: true,
      /*商城名称*/
      shop_name: "",
      /*背景图片*/
      bgimg_url: "",
      /*是否正在提交*/
      logining: false,
      /*表单对象*/
      ruleForm: {
        /*用户名*/
        account: "",
        /*密码*/
        checkPass: "",
        /*验证码*/
        code: ""
      },
      /*验证规则*/
      rules: {
        /*用户名*/
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        /*密码*/
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // 验证码
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      /*基础配置*/
      baseData: {}
    };
  },
  created() {
    let loginInfo = JSON.parse(localStorage.getItem("shopLogin"));
    let loginExpiry = localStorage.getItem("shopExpiry");
    if (loginExpiry) {
      const expiryTime = parseInt(loginExpiry, 10);
      const currentTime = Date.now();
      if (currentTime < expiryTime) {
        console.log(loginInfo, "loginInfo");
        this.ruleForm.account = loginInfo.username
        this.ruleForm.checkPass = loginInfo.password
        this.ruleForm.code = loginInfo.code

      }
    }
    this.getData();
    if (this.$route.query.from && this.$route.query.from == "admin") {
      this.saasLogin();
    }
  },
  methods: {
    sendCode() {
      if (this.codeSending) return;
      this.codeSending = true;
      // 这里模拟发送验证码到服务器
      console.log("Sending code...");

      // 重置倒计时
      this.intervalId = setInterval(() => {
        if (this.codeTimer <= 0) {
          clearInterval(this.intervalId);
          this.codeSending = false;
          this.codeTimer = 60; // 可以选择在这里重新发送验证码
        } else {
          this.codeTimer--;
        }
      }, 1000);
      console.log("111-111");
      this.getVerifyCode();
      // 实际上你应该在这里调用一个API来获取验证码
      // axios.post('/api/send-code', { account: this.ruleForm.account }).then(response => {
      //   // 处理响应
      // }).catch(error => {
      //   // 处理错误
      // });
    },

    /*获取基础配置*/
    getData() {
      let self = this;
      console.log("111-111");
      IndexApi.base(true)
        .then(res => {
          self.loading = false;
          self.shop_name = res.data.settings.shop_name;
          if (res.data.settings.shop_bg_img != "") {
            self.bgimg_url = res.data.settings.shop_bg_img;
          } else {
            self.bgimg_url = bgimg;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // /*获取验证码*/
    getVerifyCode() {
      let self = this;
      UserApi.loginCode({ username: self.ruleForm.account }, true)
        .then(res => {
          self.loading = false;
          console.log(res, "res");
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*登录方法*/
    SubmitFunc(ev) {
      var _this = this;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.logining = true;
          var Params = {
            username: this.ruleForm.account,
            password: this.ruleForm.checkPass,
            code: this.ruleForm.code
          };
          console.log(Params, "Params");
          /*调用登录接口*/
          UserApi.login(Params, true)
            .then(res => {
              this.logining = false;
              if (res.code == 1) {
                localStorage.setItem("shopLogin", JSON.stringify(Params));
                const threeDaysLater = Date.now() + 3 * 24 * 60 * 60 * 1000;
                localStorage.setItem("shopExpiry", threeDaysLater.toString());
                localStorage.setItem("authToken3", res.data.token);
                /*保存个人信息*/
                setCookie("userinfo", res.data);
                /*设置一个登录状态*/
                setCookie("isLogin", true);
                /*跳转到首页*/
                this.$router.push({ path: "/" });
              } else {
                this.$message({
                  message: "登录失败",
                  type: "error"
                });
              }
            })
            .catch(error => {
              //接口调用方法统一处理
              this.logining = false;
            });
        }
      });
    },
    saasLogin() {
      /*调用登录接口*/
      UserApi.saasLogin({}, true)
        .then(res => {
          console.log(res);
          if (res.code == 1) {
            delCookie("baseInfo");
            /*保存个人信息*/
            setCookie("userinfo", res.data);
            /*设置一个登录状态*/
            setCookie("isLogin", true);
            /*跳转到首页*/
            this.$router.push({ path: "/" });
          } else {
            this.$message({
              message: "登录失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.login-bg {
  .el-form-item__content {
    display: flex;
  }
}
</style>
<style lang="scss" scoped>
.login-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.login-container {
  box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.1), 0 1px 0px 0 rgba(0, 0, 0, 0.04);
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  position: fixed;
  width: 350px;
  left: 50%;
  top: 50%;
  margin-left: -175px;
  margin-top: -175px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }

  .login_btn {
    background-image: linear-gradient(
      to right,
      #0d204e 0%,
      #3e6b8a 50%,
      #eb744c 100%
    );

    &:hover {
      filter: contrast(120%);
    }

    &:active {
      filter: contrast(80%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue